import {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import {
    ARRAY_TASKS,
    CHECK_ALL,
    FILTER_PROJECT_CURRENT_BOARD,
    FILTER_PROJECT_CURRENT_PROJECT,
    FROM_LIBRARY,
    HEADER_HEIGHT,
    KEY_FILTER_SELECT_PROJECT_HIGHLIGHT,
    KEY_HIGHLIGHT_SELECTED_TYPES,
    KEY_LIBRARY_SELECTED_TYPES,
    KEY_TASK_FILTER_TYPE,
    KEY_TASK_TYPE_SWITCHER,
    KEY_TYPE_SWITCHER,
    MENU_SEPARATOR,
    SEARCH_WIDTH
} from "@/Const";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {IconHomeSearch} from "@/Icon";
import {
    decodeDeeplink,
    formatDate, generateUUID2,
    getImagePathWithTheme,
    getItem,
    imgPathPerfix,
    isDarkMode,
    isStringNullOrEmpty,
    sleep
} from "@/utils";
import {Checkbox, ConfigProvider, Dropdown, Input, Select, Tooltip } from "antd";
import { t } from "i18next";
import {getCardById, getCardDoc, getCardList, getNoteList, updateCard} from "@model/index";
import {APP_WEB_WWW} from "@/electron_interactive";
import {atomSliderWidth} from "@/App";
import {useAtom} from "jotai";
import './PageTask.css'
import style from "@/views/Library/PageLibrary.module.less";
import DialogTasksTypeSwitcher from "@/views/Task/DialogTasksTypeSwitcher";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Indent} from "@/components/EditorV2/indent";
import Link from "@/components/EditorV2/extension-link/src";
import Image from "@/components/EditorV2/imgResize";
import {deepLinkToLinkInfo} from "@/Utility";
import {imgServer} from "@/components/EditorV2/imgServer";
import {DatePicker} from "@/components/DatePickerPop/DatePickerManager";

const PageTask = forwardRef((props:{from?:any},ref)=>{

    const [searchKey,setSearchKey] = useState('');
    const [isOpenProjectType,setIsOpenProjectType] = useState(false);
    const [isOpenProjectSelect,setIsOpenProjectSelect] = useState(false);
    const [selectProjectValue,setSelectProjectValue] = useState('all');
    const [arrayProjects,setArrayProjects] = useState<any>([]);
    const [arrayLibraryTypes,setArrayLibraryTypes] = useState(ARRAY_TASKS());
    const [arrayTypeSwitcher,setArrayTypeSwitcher] = useState<any>([]);
    const [isEmptyTask,setIsEmptyTask] = useState(false);

    const [todoArr, setTodoArr] = useState<any>([]);

    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);

    const mSearchKey = useRef('');
    const mArrayProjects = useRef<any>([]);
    const mSelectProjectId = useRef('all');
    const mArraySelectedTypes = useRef<any>(null);
    const dialogTasksTypeSwitcherRef = useRef(null);
    const [selectedFilters, setSelectedFilters] = useState<any>({
        Today: [],
        Overdue: [],
        Upcoming: [],
        NoDuedate: [],
        Complete: []
    });
    const mArrayAllCards = useRef([]);

    const ARRAY_DEFAULT_TASKS = ()=>{
        return [
            {
                value:'all',
                label:t("All"),
                icon:''
            },
            {
                value:'today',
                label:t("Today"),
                icon:''
            },
            {
                value:'upcoming',
                label:t("Upcoming"),
                icon:''
            },
            {
                value:'overdue',
                label:t("Overdue"),
                icon:''
            },
        ];
    }

    useEffect(() => {

        getAllTodoItems();

        //类型
        let arrayTypes:any;
        const szTypes = localStorage.getItem(KEY_TASK_FILTER_TYPE);
        if (szTypes){
            arrayTypes = JSON.parse(szTypes);
        }else{
            arrayTypes = ARRAY_TASKS();
            for (let i=0;i<arrayTypes.length;i++){
                arrayTypes[i].isChecked = true;
            }
        }
        setArrayLibraryTypes(arrayTypes);

        //type switcher
        const szTypeSwitcher = localStorage.getItem(KEY_TASK_TYPE_SWITCHER);
        if (szTypeSwitcher){
            const jsonTypeSwitcher = JSON.parse(szTypeSwitcher);
            //语言问题...
            for (let i=0;i<jsonTypeSwitcher.length;i++){
                const item = jsonTypeSwitcher[i];
                const df = ARRAY_TASKS().find(p=>p.value == item.value);
                if (df){
                    item.label = df.label;
                }
            }
            setArrayTypeSwitcher(jsonTypeSwitcher);
        }else{
            setArrayTypeSwitcher(ARRAY_DEFAULT_TASKS());
        }

        //查询所有project
        getNoteList().then((res:any)=>{
            mArrayProjects.current.length = 0;

            mArrayProjects.current.push({
                value:'all',
                label:t("Projects")
            });
            mArrayProjects.current.push({
                value:'all-0',//allInProject
                label:t("All projects")
            });
            mArrayProjects.current.push({
                value:'notInProject',
                label:t("Not in any project")
            })

            if (props.from == FROM_LIBRARY){
                //库里面，增加2个
                mArrayProjects.current.push({
                    value:FILTER_PROJECT_CURRENT_PROJECT,
                    label:t("Current project")
                })
                mArrayProjects.current.push({
                    value:FILTER_PROJECT_CURRENT_BOARD,
                    label:t("Current board")
                })
            }

            mArrayProjects.current.push({
                id:MENU_SEPARATOR,
                label:'',
                value:'spe0'
            })
            res.forEach(p=>{
                mArrayProjects.current.push({
                    value:p.id,
                    label:p.name
                })
            })
            setArrayProjects(mArrayProjects.current);
        })

        //刷新单个refresh
        window.refreshList['refresh_tasks_'] = (data)=>{
            getAllTodoItems();
        }

        return ()=>{
            delete window.refreshList['refresh_tasks_'];
        }
    }, []);

    const getAllTodoItems = () => {
        // 获取所有todo项
        getCardList(-1,0,['card','journal'],'','').then(list => list.sort((a, b) => a.createTime - b.createTime)).then(async res => {
            mArrayAllCards.current = res;
            let tempTodoArr:any = []
            await Promise.all(res.map(async item => {
                let doc = await getCardDoc(item.id);
                window.publicEditor?.commands.setContent(doc)
                // 手动查找赋值id
                // const listItems = doc.querySelectorAll('li[data-checked]');
                // const dataIds = Array.from(listItems).map(li => li.getAttribute('data-id'));
                // let taskItemIndex = 0
                window.publicEditor?.state.doc.descendants((node, pos) => {
                    if (node.type.name === 'taskItem') {
                        // node.taskItemId = dataIds[taskItemIndex]
                        if (tempTodoArr.length === 0 || tempTodoArr[tempTodoArr.length - 1].id !== item.id) {
                            tempTodoArr.push({
                                ...item,
                                node: [node]
                            })
                        } else {
                            tempTodoArr[tempTodoArr.length - 1].node = [...tempTodoArr[tempTodoArr.length - 1].node, node]
                        }
                        // taskItemIndex++;
                        setIsEmptyTask(false);
                    }
                    return true;
                })
            }))
            setTodoArr(tempTodoArr)
        })
    }

    // 分类任务
    const categorizedTasks = useMemo(() => {
        const categories = {
            Today: [],
            Overdue: [],
            Upcoming: [],
            NoDuedate: [],
            Complete: []
        };

        // 获取当前日期
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        todoArr.forEach(note => {
            note.node.forEach(task => {
                const dueDate = (task.attrs?.dueDate !== '0' && task.attrs?.dueDate !== '-1') ? new Date(Number(task.attrs.dueDate)) : null;
                const isCompleted = task.attrs?.checked || false;
                if (isCompleted) {
                    categories.Complete.push({ note, task });
                } else if (!dueDate) {
                    categories.NoDuedate.push({ note, task });
                } else {
                    dueDate.setHours(0, 0, 0, 0);
                    const diffTime = dueDate.getTime() - today.getTime();
                    const diffDays = diffTime / (1000 * 60 * 60 * 24);
                    if (diffDays === 0) {
                        categories.Today.push({ note, task });
                    } else if (diffDays < 0) {
                        categories.Overdue.push({ note, task });
                    } else {
                        categories.Upcoming.push({ note, task });
                    }
                }
            });
        });
        return categories;
    }, [todoArr]);

    /**
     * 刷新task
     */
    const refreshTasks = ()=>{

    }

    /**
     * 更多菜单
     */
    const getLibraryMoreMenu = ()=>{
        return [
            getItem(t("DeleteEmptyTasks"), 'deleteEmptyCards', null, undefined, undefined, () => {

            }),
        ]
    }

    /**
     * 类型条目点击....
     * @param p
     * @param isChecked
     */
    const onCheckedItemClicked = (p,isChecked)=>{

        var arrayNew = [...arrayLibraryTypes];

        if (p.value == CHECK_ALL) {
            arrayNew.forEach(pp => pp.isChecked = isChecked);
        }else {
            p.isChecked = isChecked;

            //判断all
            // const itemAll = arrayNew[arrayNew.length -1];
            // itemAll.isChecked = arrayNew.filter(pp=>pp.isChecked && pp.value != MENU_SEPARATOR && pp.value != CHECK_ALL).length == (arrayNew.length - 2);
        }

        mArraySelectedTypes.current = arrayNew;
        setArrayLibraryTypes(arrayNew);

        localStorage.setItem(KEY_TASK_FILTER_TYPE, JSON.stringify(arrayNew));

        const nCheckedCount = arrayNew.filter(p=>p.isChecked).length;
        if (nCheckedCount != arrayNew.length){
            if (nCheckedCount == 1){
                //取选中的第一个...

                const arrayNewTypeSwitcher = [...arrayTypeSwitcher];
                arrayNewTypeSwitcher.forEach(p=>{
                    p.isSelected = false;
                })
                const selectedItem = arrayNew.find(p=>p.isChecked);
                if (selectedItem){
                    const typeSwitcher = arrayNewTypeSwitcher.find(p=>p.value == selectedItem.value);
                    if (typeSwitcher){
                        typeSwitcher.isSelected = true;
                    }
                }
                localStorage.setItem(KEY_TASK_TYPE_SWITCHER,JSON.stringify(arrayNewTypeSwitcher));
                setArrayTypeSwitcher(arrayNewTypeSwitcher);

            }else{
                //清空侧边需要选择的...
                const arrayNew = [...arrayTypeSwitcher];
                arrayNew.forEach(p=>{
                    p.isSelected = false;
                })
                localStorage.setItem(KEY_TASK_TYPE_SWITCHER,JSON.stringify(arrayNew));
                setArrayTypeSwitcher(arrayNew);
            }
        }else{
            //判断是否要显示这个图标--根据别的筛选...
            //这里全选了...
            const arrayNew = [...arrayTypeSwitcher];
            arrayNew.forEach(p=>{
                p.isSelected = false;
            })
            const allType = arrayNew.find(p=>p.value == 'all');
            if (allType){
                allType.isSelected = true;
            }
            localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNew));
            setArrayTypeSwitcher(arrayNew);
        }

        //刷新列表
        refreshTasks()
    }

    /**
     * 只选择一种类型.
     * @param p
     */
    const onCheckOneItem = (p)=>{
        setIsOpenProjectType(false);
        //只显示这一种类型..
        const arrayNewType = [...arrayLibraryTypes];
        arrayNewType.forEach(item => {
            item.isHoverd = false;
            item.isChecked = false;
        });
        p.isChecked = true;

        mArraySelectedTypes.current = arrayNewType;
        setArrayLibraryTypes(arrayNewType);
        localStorage.setItem(KEY_TASK_FILTER_TYPE, JSON.stringify(arrayNewType));

        //type switcher 部分
        const arrayNewTypeSwitcher = [...arrayTypeSwitcher];
        arrayNewTypeSwitcher.forEach(p=>{
            p.isSelected = false;
        })
        const typeSwitcher = arrayNewTypeSwitcher.find(pp=>pp.value == p.value);
        if (typeSwitcher){
            typeSwitcher.isSelected = true;
        }
        localStorage.setItem(KEY_TYPE_SWITCHER,JSON.stringify(arrayNewTypeSwitcher));
        setArrayTypeSwitcher(arrayNewTypeSwitcher);
        //end....


        //刷新列表
        refreshTasks()
    }


    // 渲染分类section
    const renderCategorySection = (categoryName, tasks,szColor) => {
        const isFilterCheck = arrayLibraryTypes.some(p=>p.isChecked && p.value.toLowerCase() == categoryName.toLowerCase());
        if (!selectedFilters[categoryName] || tasks.length === 0 || !isFilterCheck) {
            return null;
        }

        if (categoryName === 'Upcoming' || categoryName === 'Overdue') {
            // 改变排序规则
            tasks = tasks.sort((a, b) => a.task.attrs.dueDate - b.task.attrs.dueDate)
        }

        return (
            <div key={categoryName} style={{ marginBottom: '24px' }}>
                <div style={{
                    fontSize: '18px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span className={'font-family-semi-bold'} style={{color:szColor}}>{t(categoryName)}</span>
                    <span className={'flex-center default-font-size default-font-family'} style={{width:'22px',height:'22px', background:'var(--content-anno-count-background)',borderRadius:'14px' }}>
                        {tasks.length}
                    </span>
                </div>
                <div>
                    {tasks.map((item, index) => renderTaskItem(item, index))}
                </div>
            </div>
        );
    };


    /**
     * 改变taskitem的checkbox
     * @param note 所属卡片信息
     * @param task taskitem节点信息
     * @param changeValue checkbox的值
     */
    const handleCheckboxChange = async (note, task, changeValue) => {
        const notedoc = await getCardDoc(note.id);
        window.publicEditor?.commands.setContent(notedoc);
        const { state, view } = window.publicEditor;
        const { dispatch } = view;
        const { schema } = state;
        const tr = state.tr;
        const selectNodeNP = window.publicEditor?.$doc.querySelectorAll('taskItem', { id: task.attrs.id })[0]
        // 为什么selectNodeNP.node.attrs.checked没变？
        tr.setNodeMarkup(selectNodeNP.pos - 1, schema.nodes[`${selectNodeNP.node.type.name}`], {
            ...selectNodeNP.node.attrs,
            checked: changeValue
        });
        dispatch(tr);
        // 保存到数据库
        const html = imgServer.parserImgFromHtml(window.publicEditor?.getHTML() as string);
        const name = note?.name;
        let createTime = note.createTime;
        let updateTime = Date.now();
        if (!createTime) {
            createTime = updateTime;
        }
        // const data = {
        //     doc: html,
        //     thumbHtml: html,
        //     id: note.id,
        //     type: 'card',
        //     isDeleted: 0,
        //     name: name || '',
        //     createTime,
        //     updateTime
        // };
        // postMessage(EVENT_UPDATE_NOTE, { data: data, isInsertCanvas: false, isAutoSave: true });
        await sleep(10)
        setTodoArr(prev =>
            prev.map(n => {
                if (n.id !== note.id) return n;
                return {
                    ...n,
                    node: n.node.map(t =>
                        t.attrs.id === task.attrs.id ? { ...t, attrs: { ...t.attrs, checked: changeValue }, textContent: task.textContent } : t
                    ),
                    doc: html
                };
            })
        );
        // getAllTodoItems()
    };

    /**
     * 改变taskitem中的duedate
     * @param note 所属卡片信息
     * @param task taskitem节点信息
     * @param changeValue duedate的值
     */
    const handleDuedateChange = async (note, task, changeValue) => {
        const notedoc = await getCardDoc(note.id);
        window.publicEditor?.commands.setContent(notedoc);
        const { state, view } = window.publicEditor;
        const { dispatch } = view;
        const { schema } = state;
        const tr = state.tr;

        const selectNodeNP = window.publicEditor?.$doc.querySelectorAll('taskItem', { id: task.attrs.id })[0]
        tr.setNodeMarkup(selectNodeNP.pos - 1, schema.nodes[`${selectNodeNP.node.type.name}`], {
            ...selectNodeNP.node.attrs,
            dueDate: changeValue
        });
        dispatch(tr);
        // 保存到数据库
        const html = imgServer.parserImgFromHtml(window.publicEditor?.getHTML() as string);
        const name = note?.name;
        let createTime = note.createTime;
        let updateTime = Date.now();
        if (!createTime) {
            createTime = updateTime;
        }
        const data = {
            ...note,
            doc: html,
            thumbHtml: html,
            name: name || '',
            createTime,
            updateTime
        };
        delete data.node;
        await updateCard(data);
        // 刷新当前页面的todolist
        setTodoArr(prev =>
            prev.map(n => {
                if (n.id !== note.id) return n;
                return {
                    ...n,
                    node: n.node.map(t =>
                        t.attrs.id === task.attrs.id ? { ...t, attrs: { ...t.attrs, dueDate: changeValue }, textContent: task.textContent } : t
                    ),
                    doc: html
                };
            })
        );
    };

    const openTodoItemInNote = (note, task) => {
        // setIsModalOpen_Todo(false)
        sessionStorage.setItem('block-id', task.attrs.id)
        sessionStorage.setItem('block-type', 'taskItem')
        sessionStorage.setItem('ifFullScreen', 'false')
        getCardById(note.id).then(res=>{
            window.showDialogCard(res);
        })
    }

    const isValidDateTitle = (a: string): boolean => {
        if (!/^\d{8}$/.test(a)) return false;

        const year = parseInt(a.slice(0, 4), 10);
        const month = parseInt(a.slice(4, 6), 10) - 1; // JS month is 0-based
        const day = parseInt(a.slice(6, 8), 10);

        const date = new Date(year, month, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() === month &&
            date.getDate() === day
        );
    };

    const changeDuedate = async (event, note, task) => {
        let selectedDate = await DatePicker.open(event.pageX, event.pageY, (date: string) => { }, task.attrs.dueDate);
        let anotherFormatDate = selectedDate.replace(/-/g, "")
        // 判断是否是 标题名是否为日期格式
        if (isValidDateTitle(note.name) && note.name !== anotherFormatDate) {
            // 判断目标卡片是否存在  没有就添加
            let targetCard = mArrayAllCards.current.find(card => card.name === anotherFormatDate)
            let existCard
            if (!targetCard) {
                // 先添加笔记
                existCard = await updateCard({
                    id: generateUUID2(),
                    doc: "<p ifhidden=\"false\"></p>",
                    type: "card",
                    name: anotherFormatDate,
                })
                await sleep(200)
            } else {
                existCard = targetCard;
            }
            {
                // 将元素添加到目标笔记末尾
                // 需要修改task的duedate!!!
                const year = parseInt(anotherFormatDate.slice(0, 4), 10);
                const month = parseInt(anotherFormatDate.slice(4, 6), 10) - 1; // JS月份从0开始
                const day = parseInt(anotherFormatDate.slice(6, 8), 10);
                const date = new Date(year, month, day, 12, 0, 0); // 中午12点
                task.attrs.dueDate = String(date.getTime())
                const notedoc = await getCardDoc(existCard.id);
                window.publicEditor?.commands.setContent(notedoc);
                const { state, view } = window.publicEditor;
                const { doc, tr } = state;
                const endPos = doc.content.size;
                const transaction = tr.insert(endPos, task);
                view.dispatch(transaction);
                // 保存
                const html = imgServer.parserImgFromHtml(window.publicEditor?.getHTML() as string);
                const name = existCard?.name;
                let createTime = existCard.createTime;
                let updateTime = Date.now();
                if (!createTime) {
                    createTime = updateTime;
                }
                const data = {
                    ...existCard,
                    doc: html,
                    name: name || '',
                    createTime,
                    updateTime
                };
                await updateCard(data);
                // postMessage(EVENT_UPDATE_NOTE, { data: data, isInsertCanvas: false, isAutoSave: true });
            }

            {
                // 将元素从原笔记中删除
                const notedoc = await getCardDoc(note.id);
                window.publicEditor?.commands.setContent(notedoc);
                const { state, view } = window.publicEditor;
                const { doc, tr } = state;
                const endPos = doc.content.size;
                const taskItemSourceNP = window.publicEditor?.$doc.querySelectorAll('taskItem', { id: task.attrs.id })[0]

                const $pos = doc.resolve(taskItemSourceNP.pos);
                const parentNode = $pos.node(1);
                // 需要判断是否是嵌套listitem
                if (taskItemSourceNP.depth <= 3) {
                    if (parentNode.type.name === "taskList" && parentNode.childCount === 1) {
                        // 直接把整个list移除
                        const taskListSourceNP = window.publicEditor?.$doc.querySelectorAll('taskList', { id: parentNode.attrs.id })[0]
                        view.dispatch(tr.delete(taskListSourceNP.from - 1, taskListSourceNP.to - 1));
                    } else {
                        view.dispatch(tr.delete(taskItemSourceNP.from - 1, taskItemSourceNP.to));
                    }
                } else {
                    view.dispatch(tr.delete(taskItemSourceNP.from - 2, taskItemSourceNP.to));
                }
                // 保存
                const html_source = imgServer.parserImgFromHtml(window.publicEditor?.getHTML() as string);
                const name_source = note?.name;
                let createTime_source = note.createTime;
                let updateTime_source = Date.now();
                if (!createTime_source) {
                    createTime_source = updateTime_source;
                }
                const data_source = {
                    doc: html_source,
                    thumbHtml: html_source,
                    id: note.id,
                    type: 'card',
                    isDeleted: 0,
                    name: name_source || '',
                    createTime: createTime_source,
                    updateTime: updateTime_source
                };
                // postMessage(EVENT_UPDATE_NOTE, { data: data_source, isInsertCanvas: false, isAutoSave: true });
            }

            // 对当前页面进行变化
            setTimeout(() => {
                getAllTodoItems()
            }, 100);
        } else {
            // 改变这个值
            if (selectedDate !== '-1' && selectedDate !== '0') {
                const [year, month, day] = selectedDate.split('-').map(Number);
                const noon = new Date(year, month - 1, day, 12, 0, 0, 0);
                selectedDate = String(noon.getTime());
            }
            handleDuedateChange(note, task, selectedDate)
        }
    }

    const matchDate = (searchText: string, dueDateStr: string): boolean => {
        if (!searchText.trim() || dueDateStr === '0' || dueDateStr === '-1') return false;

        const dueDate = new Date(Number(dueDateStr));
        const normalizedSearch = searchText.trim().toLowerCase();

        // 提取dueDate的年月日
        const dueDateYear = dueDate.getFullYear();
        const dueDateMonth = dueDate.getMonth() + 1; // getMonth() 返回 0-11
        const dueDateDay = dueDate.getDate();

        // 月份数组
        // const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

        // 解析搜索文本中的时间要素
        let duplicateArr = []
        const parseSearchText = (text: string) => {
            // const result: {
            //     year?: number;
            //     months?: number[]; // 改为数组，支持多个月份
            //     day?: number | string;
            // } = {};

            let finalResArr = []
            const regex = /^(?:[A-Za-z]+|\d+|[A-Za-z]+\s+\d+)$/;
            if (!regex.test(text)) {
                return false;
            }
            // 移除标点符号，分割为词组
            const words = text.replace(/[^\w\s]/g, ' ').split(/\s+/).filter(word => word.length > 0);
            let ifExistBadWord = false;

            for (let i = 0; i < words.length; i++) {
                const word = words[i];

                // 检查是否为月份名称 - 收集所有匹配的月份
                const matchedMonths: number[] = [];
                for (let j = 0; j < months.length; j++) {
                    if (months[j].startsWith(word)) {
                        matchedMonths.push(j + 1); // 月份从1开始
                    }
                }

                if (matchedMonths.length > 0) {
                    // result.months = matchedMonths;
                    finalResArr.push({
                        possibleDateProperty: ['month'],
                        data: {
                            month: matchedMonths
                        }
                    })

                    // 检查下一个词是否为日期
                    if (i + 1 < words.length) {
                        const nextWord = words[i + 1];
                        // result.day = nextWord
                        let day = nextWord
                        const nextNum = parseInt(nextWord);
                        if (!isNaN(nextNum) && nextNum >= 1 && nextNum <= 31 && /^\d+$/.test(nextWord)) {
                            // result.day = nextNum;
                            day = nextNum;
                            i++; // 跳过下一个词，因为已经处理了
                        }
                        finalResArr.push({
                            possibleDateProperty: ['day'],
                            data: {
                                day: day
                            }
                        })
                    }
                }
                // 检查是否为数字
                else if (/^\d+$/.test(word)) {
                    const num = parseInt(word);
                    let detectEle = {
                        possibleDateProperty: [],
                        data: {}
                    }
                    // 4位数字识别为年份
                    if (num <= 9999) {
                        // result.year = num;
                        detectEle.possibleDateProperty.push('year')
                        detectEle.data.year = num;
                    }
                    // 1-12的数字，如果还没有月份，识别为月份
                    if (num >= 1 && num <= 12) {
                        // result.months = [num];
                        detectEle.possibleDateProperty.push('month')
                        detectEle.data.month = num;
                    }
                    // 1-31的数字，如果还没有日期，识别为日期
                    if (num >= 1 && num <= 31) {
                        // result.day = num;
                        detectEle.possibleDateProperty.push('day')
                        detectEle.data.day = num;
                    }
                    finalResArr.push(detectEle)
                } else {
                    ifExistBadWord = true
                }
            }
            if (ifExistBadWord) {
                return false;
            }
            return finalResArr;
        };

        const searchDateParts = parseSearchText(normalizedSearch);
        if (typeof searchDateParts === "boolean" && searchDateParts === false) {
            return false;
        }

        // 找出所有只包含一个元素的属性值
        const singleProperties = new Set<string>();
        searchDateParts.forEach(item => {
            if (item.possibleDateProperty.length === 1) {
                singleProperties.add(item.possibleDateProperty[0]);
            }
        });

        // 处理数组，剔除掉其他元素中 >=2 的 possibleDateProperty 中的 singleProperties
        const newSearchDateParts = searchDateParts.map(item => {
            if (item.possibleDateProperty.length >= 2) {
                return {
                    ...item,
                    possibleDateProperty: item.possibleDateProperty.filter(
                        prop => !singleProperties.has(prop)
                    ),
                };
            }
            return item;
        });

        function monthCompare(targetMonth, providaMonth) {
            if (typeof providaMonth === "number") {
                return providaMonth.toString().startsWith(targetMonth?.toString())
            } else if (Array.isArray(providaMonth)) {
                return providaMonth.some(item => item.toString().startsWith(targetMonth?.toString()))
            }
        }
        function filterByDate(
            year: number,
            month: number,
            day: number,
            arr: any[]
        ): any[] {
            let ifExsitFaild = false
            const dealArr = arr.map(item => {
                const newData: Record<string, any> = { ...item.data };
                let newPossible = [...item.possibleDateProperty];
                let failedCount = 0
                // 检查 year
                if ("year" in newData && !year.toString().startsWith(newData.year?.toString())) {
                    delete newData.year;
                    newPossible = newPossible.filter(p => p !== "year");
                    failedCount++
                }

                // 检查 month
                if ("month" in newData && !monthCompare(month, newData.month)) {
                    delete newData.month;
                    newPossible = newPossible.filter(p => p !== "month");
                    failedCount++
                }

                // 检查 day
                if ("day" in newData && !day.toString().startsWith(newData.day?.toString())) {
                    delete newData.day;
                    newPossible = newPossible.filter(p => p !== "day");
                    failedCount++
                }
                if (failedCount === item.possibleDateProperty.length) {
                    ifExsitFaild = true;
                }

                return {
                    ...item,
                    data: newData,
                    possibleDateProperty: newPossible
                };
            });
            if (ifExsitFaild) {
                return ifExsitFaild
            }
            return dealArr;
        }
        const filterRes = filterByDate(dueDateYear, dueDateMonth, dueDateDay, newSearchDateParts)
        if (typeof filterRes === "boolean" && filterRes === true) {
            return false;
        }
        const finalRes = filterRes
            .map(item => item.data)
            .filter(data => Object.keys(data).length > 0);
        return finalRes.length === 0 ? false : true
    };

    // 搜索过滤
    const filteredTasks = useMemo(() => {
        if (!mSearchKey.current.trim()) {
            return categorizedTasks;
        }

        const searchLower = mSearchKey.current.toLowerCase();
        const filtered = {
            Today: [],
            Overdue: [],
            Upcoming: [],
            NoDuedate: [],
            Complete: []
        };

        Object.entries(categorizedTasks).forEach(([category, tasks]) => {
            filtered[category] = tasks.filter(({ note, task }) => {
                const dueDateStr = task.attrs?.dueDate || '';
                const noteTitle = note.name.toLowerCase();
                const taskContentList = task?.firstChild ? task.firstChild.content.content : task.content.content[0].content.content;
                const taskContent = taskContentList?.map(item => item.textContent || '')
                    .join('') || '';

                return (
                    taskContent.toLowerCase().includes(searchLower) ||
                    noteTitle.includes(searchLower)
                    || matchDate(searchLower, dueDateStr)
                    // dueDateStr.toLowerCase().includes(searchLower) ||
                    // dueDateStr.includes(searchLower.replace(/\D/g, '')) ||
                    // new Date(dueDateStr || '').toLocaleDateString('en-US', {
                    //     month: 'short',
                    //     day: 'numeric',
                    //     year: 'numeric'
                    // }).toLowerCase().includes(searchLower)
                );
            });
        });
        return filtered;
    }, [categorizedTasks, searchKey]);

    // 渲染任务项
    const renderTaskItem = (item, index) => {
        const { note, task } = item;
        const checked = task.attrs?.checked || false;
        const dueDate = parseInt(task.attrs?.dueDate,10);
        const itemContent = task?.firstChild ? task.firstChild.content.content : task.content.content[0].content.content

        return (
            <div
                key={`${note.id}-${index}`}
                className="todoItemInDialog"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    margin:'0 -20px',
                    padding: '0px 20px',
                    borderRadius: '4px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', flex: 1,height:'30px' }}>
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => handleCheckboxChange(note, task, e.target.checked)}
                        style={{ marginRight: '8px' }}
                    />
                    <span
                        className="selectable-text"
                        onClick={(e) => { openTodoItemInNote(note, task) }}
                        onMouseUp={(e) => { openTodoItemInNote(note, task) }}
                        style={{
                            textDecoration: checked ? 'line-through' : 'none',
                            color: checked ? '#888' : '#000',
                            display: 'flex', alignItems: 'center', marginLeft: '3px',
                        }}>
                        {itemContent.map(taskContentItem => {
                            if (taskContentItem.type.name === 'text') {
                                if (taskContentItem.marks?.[0]?.type?.name === "code") {
                                    return <span style={{ padding: '2px 4px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>{taskContentItem.textContent}</span>
                                }
                                return <span>{taskContentItem.textContent}</span>
                            } else if (taskContentItem.type.name === 'deeplink') {
                                return <span className={'cursor-pointer'} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '14px', margin: "1 2px" }} onClick={async () => {
                                    const deeplink = decodeDeeplink(taskContentItem.attrs.href);
                                    if (deeplink.type == 'library') {
                                        // postMessage(EVENT_OPEN_LIBRARY_ITEM, { id: deeplink.id, from: FROM_LIBRARY })
                                    } else {
                                        const linkInfo = await deepLinkToLinkInfo(deeplink);
                                        // postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, { linkInfo });
                                    }
                                }}>
                                    <svg style={{ marginLeft: '-2px' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2656" width="24" height="22"><path d="M928.774707 187.553607 94.112959 187.553607c-15.363919 0-27.821649 12.489452-27.821649 27.895327l0 585.789587c0 15.405875 12.45773 27.895327 27.821649 27.895327l834.661747 0c15.362896 0 27.821649-12.489452 27.821649-27.895327L956.596356 215.448934C956.596356 200.044082 944.137603 187.553607 928.774707 187.553607zM893.005039 764.981758 129.881604 764.981758 129.881604 251.705696l763.123434 0L893.005039 764.981758z" fill="#00bfff" p-id="2657"></path><path d="M808.546461 380.025223 214.352461 380.025223c-11.532661 0-20.865213 9.370415-20.865213 20.921495l0 22.323425c0 11.550057 9.332553 20.921495 20.865213 20.921495l594.194 0c11.521404 0 20.866237-9.371438 20.866237-20.921495l0-22.323425C829.411675 389.396661 820.067866 380.025223 808.546461 380.025223z" fill="#00bfff" p-id="2658"></path><path d="M363.379613 636.662231 214.352461 636.662231c-11.532661 0-20.865213 9.356089-20.865213 20.920472l0 22.311145c0 11.564383 9.332553 20.921495 20.865213 20.921495L363.379613 700.815343c11.534707 0 20.866237-9.358135 20.866237-20.921495l0-22.311145C384.246873 646.01832 374.91432 636.662231 363.379613 636.662231z" fill="#00bfff" p-id="2659"></path></svg>
                                    <span className={'span-single-line ml-2'} style={{ color: '#00bfff' }}>{taskContentItem.attrs.text}</span>
                                </span>
                            } else if (taskContentItem.type.name === 'latexInline') {
                                let latexHtmlData = katex.renderToString(taskContentItem.attrs.metaData.replace(/\\begin{align\*?}/g, '\\begin{aligned}').replace(/\\end{align\*?}/g, '\\end{aligned}'), {
                                    throwOnError: false
                                })
                                return <div
                                    className='htmlLatex'
                                    contentEditable={false}
                                    style={{ textAlign: 'center', margin: '1px 4px' }}
                                    dangerouslySetInnerHTML={{ __html: taskContentItem.attrs.metaData.trim() === '' ? `<div style='color:#d2d2d2'>Add a Tex equation</div>` : latexHtmlData }}
                                />
                            }
                        })}
                    </span>
                </div>
                <div style={{
                    flexShrink:'0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0px',
                    width:'380px',
                }}>
                    <span style={{ minWidth: '90px', cursor: 'pointer' }} onClick={(e) => { changeDuedate(e, note, task) }}>
                        {formatDate(dueDate)}
                    </span>

                    <img className={'img-16'} style={{marginLeft:'80px'}} src={getImagePathWithTheme(note.type == 'card'?'deeplink_card':'deeplink_journal')}/>
                    <span className={'ml-6'} onClick={(e) => { openTodoItemInNote(note, task) }} style={{cursor: 'pointer' }}>
                        {note.name}
                    </span>
                </div>
            </div>
        );
    };

    const getSelectFilterTypeLabel = ()=>{
        const arrayChecked = arrayLibraryTypes.filter(p=>p.isChecked);
        if (arrayChecked.length == 1){
            return arrayChecked[0].label;
        }
        return t("Type");
    }

    return(
        <div className={'flex-row'}>
            <div id={'divPageTaskContainer'} className={'page-task-container'} style={{
                height: 'calc(100% - 0px)',
                paddingBottom: '16px',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    // minHeight: `${HEADER_HEIGHT}px`,
                    flexShrink: '0',
                    overflowX: 'hidden',
                    // padding: '0 20px',
                    padding: '7px 19px 7px 20px',
                    gap:'12px 22px',
                    position: 'relative',
                    flexWrap:'wrap',
                }}>
                    {
                        <>
                            <HomeNavigator margin={'0 16px 0 -4px'}/>
                            {
                                <Input prefix={<IconHomeSearch/>}
                                       suffix={<img className='img-mini-small-8 cursor-pointer'
                                                    style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit"}}
                                                    onClick={() => {
                                                        setSearchKey('');
                                                        mSearchKey.current = '';
                                                        refreshTasks()
                                                    }}
                                                    src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
                                       variant={"borderless"}
                                       style={{
                                           width: `${SEARCH_WIDTH}px`,
                                           height: '32px',
                                           backgroundColor: 'var(--input-background-color)'
                                       }}
                                       placeholder={t("Search tasks")} value={searchKey}
                                       onChange={(event) => {
                                           mSearchKey.current = event.currentTarget.value
                                           setSearchKey(mSearchKey.current);
                                           refreshTasks()
                                       }}/>
                            }
                        </>
                    }

                    {/*分类类型切换...card - pdf image  video audio*/}
                    <div className={'flex-row-vertical-center select-popup-class'} style={{
                        width: props.from == FROM_LIBRARY ? '108px' : '138px',
                        // marginLeft: props.from == FROM_LIBRARY ? '0' : '22px',
                        borderRadius: '8px',
                        paddingLeft: '12px',
                        position: 'relative',
                        height: '32px',
                        border: '1px solid var(--input-border-color)',
                    }}>
                        <img className={'img-14'} src={getImagePathWithTheme('filter_tasks.svg')}/>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        /* 这里是你的组件 token */
                                        colorBorder: 'transparent',
                                        colorPrimaryHover: 'transparent',
                                        colorPrimary: 'transparent',
                                    },
                                },
                            }}>
                            {
                                <Select
                                    open={isOpenProjectType}
                                    value={getSelectFilterTypeLabel()}
                                    style={{
                                        width: '100%',
                                        position: 'absolute',
                                        left: '0',
                                        paddingLeft: '0px',
                                        marginTop: '0px',
                                    }}
                                    onDropdownVisibleChange={(e) => setIsOpenProjectType(e)}
                                    onChange={(value, option) => {

                                    }}
                                    dropdownRender={(menu) => {
                                        return (
                                            <div style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                                                <>
                                                    {
                                                        arrayLibraryTypes.map(p =>
                                                            <>
                                                                {
                                                                    p.value == MENU_SEPARATOR &&
                                                                    <div key={p.value} className={'line'}
                                                                         style={{margin: '4px 0'}}></div>
                                                                }
                                                                {
                                                                    p.value !== MENU_SEPARATOR &&
                                                                    <div key={p.value} className={'dropdown-item'}
                                                                         onClick={(event) => {
                                                                             onCheckedItemClicked(p, !p.isChecked)
                                                                         }} onMouseEnter={() => {
                                                                        const arrayNewType = [...arrayLibraryTypes];
                                                                        arrayNewType.forEach(p => p.isHoverd = false);
                                                                        p.isHoverd = true;
                                                                        mArraySelectedTypes.current = arrayNewType;
                                                                        setArrayLibraryTypes(arrayNewType);
                                                                    }} onMouseLeave={() => {
                                                                        const arrayNewType = [...arrayLibraryTypes];
                                                                        arrayNewType.forEach(p => p.isHoverd = false);
                                                                        mArraySelectedTypes.current = arrayNewType;
                                                                        setArrayLibraryTypes(arrayNewType);
                                                                    }} style={{
                                                                        background: 'transparent',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }}>
                                                                    <span className={'span-single-line'} style={{
                                                                        paddingLeft: '12px',
                                                                        paddingRight: '12px',
                                                                        color: 'var(--text-color)'
                                                                    }}>{p.label}</span>

                                                                        <div className={'flex-row-vertical-center'}
                                                                             style={{marginLeft: 'auto'}}>
                                                                            {
                                                                                p.isHoverd && p.value != CHECK_ALL &&
                                                                                <Tooltip title={t("ShowOnlyThis")}
                                                                                         arrow={false}>
                                                                                    <img style={{marginLeft: 'auto'}}
                                                                                         className={'img-16 no-filter mr-6'}
                                                                                         src={getImagePathWithTheme('library_eye_this')}
                                                                                         onClick={(e) => {
                                                                                             e.stopPropagation();
                                                                                             e.preventDefault();
                                                                                             onCheckOneItem(p);
                                                                                         }}/>
                                                                                </Tooltip>
                                                                            }

                                                                            <Checkbox style={{
                                                                                marginLeft: '4px',
                                                                                marginRight: '8px',
                                                                                pointerEvents: 'none'
                                                                            }} checked={p.isChecked} onChange={(e) => {
                                                                                // onCheckedItemClicked(p,e.target.checked)
                                                                            }}></Checkbox>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            </div>
                                        )
                                    }}
                                    suffixIcon={<img className='img-mini-small-10' onClick={() => {
                                        setIsOpenProjectType(true)
                                    }}
                                                     src={getImagePathWithTheme('drop_down_select')}/>}
                                    dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                                </Select>
                            }
                        </ConfigProvider>
                    </div>


                    {/*project 按所在项目过滤..all  all in project  not in project*/}
                    <div className={'flex-row-vertical-center select-popup-class'} style={{
                        paddingLeft: '12px',
                        borderRadius: '8px',
                        position: 'relative',
                        height: '32px',
                        border: '1px solid var(--input-border-color)',
                        width: props.from == FROM_LIBRARY ? '108px' : '138px',
                        // marginLeft: props.from == FROM_LIBRARY ? '12px' : '22px'
                    }}>
                        {
                            <img className={'img-18'} src={getImagePathWithTheme('filter_project.svg')}/>
                        }

                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        /* 这里是你的组件 token */
                                        colorBorder: 'transparent',
                                        colorPrimaryHover: 'transparent',
                                        colorPrimary: 'transparent',
                                    },
                                },
                            }}>
                            <Select
                                showSearch={true}
                                open={isOpenProjectSelect}
                                onDropdownVisibleChange={(e) => setIsOpenProjectSelect(e)}
                                value={selectProjectValue}
                                style={{
                                    width: '100%',
                                    position: 'absolute',
                                    left: '0',
                                    marginTop: '1px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                options={arrayProjects}
                                onChange={value => {
                                    setSelectProjectValue(value);
                                }}
                                onSearch={value => {
                                    value = value.toLowerCase();
                                    if (isStringNullOrEmpty(value)) {
                                        setArrayProjects(mArrayProjects.current);
                                    } else {
                                        var arrayNewProject = mArrayProjects.current.filter((p) => {
                                            return p.label?.toLowerCase().indexOf(value) != -1;
                                        });
                                        setArrayProjects(arrayNewProject);
                                    }
                                }}
                                dropdownRender={(menu) => {
                                    return (
                                        <div style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                                            {
                                                arrayProjects.map(p =>
                                                    <>
                                                        {
                                                            p.id == MENU_SEPARATOR &&
                                                            <div key={p.id} className={'line'}
                                                                 style={{margin: '4px 0'}}></div>
                                                        }
                                                        {
                                                            p.id !== MENU_SEPARATOR && p.value != 'all' &&
                                                            <div key={p.value} className={'dropdown-item'}
                                                                 onClick={async () => {
                                                                     setIsOpenProjectSelect(false);
                                                                     setSelectProjectValue(p.label);
                                                                     mSelectProjectId.current = p.value;

                                                                     refreshTasks();
                                                                 }}>
                                                    <span className={'span-single-line'} style={{
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px'
                                                    }}>{p.label}</span>
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    )
                                }}
                                suffixIcon={<img className='img-mini-small-10'
                                                 onClick={() => setIsOpenProjectSelect(true)}
                                                 src={getImagePathWithTheme('drop_down_select')}/>}
                                dropdownStyle={{width: '228px', overflowY: 'auto'}}>
                            </Select>
                        </ConfigProvider>
                    </div>


                    <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                        <div className='button-max-height newcard-border-gray-style-no-hover flex-center font-size-12'
                             onClick={() => {
                                 onEditTag(t("Create tag"), null);
                             }}
                             style={{marginLeft: '1px', height: '32px', borderRadius: '8px', minWidth: '110px'}}>
                            {/*imgPathPerfix() + (isHoverAddTag ? 'add_blue.png' : (isDarkMode() ? 'add_white.png' : 'add_tag_s.png'))*/}
                            <img className='img-mini-small-12'
                                 src={getImagePathWithTheme('add_black')}/>
                            <span className='ml-6'>{t("Add tasks")}</span>
                        </div>

                        <Dropdown overlayClassName='default-dropdown-style'
                                  overlayStyle={{minWidth: '160px'}}
                                  menu={{items: getLibraryMoreMenu()}} trigger={['click']}>
                            <img className={'img-32 ml-10 cursor-pointer'}
                                 onClick={(e) => e.preventDefault()}
                                 src={getImagePathWithTheme('library_more')}/>
                        </Dropdown>

                        {
                            rightSliderWidth == 0 &&
                            <img className='img-32 hovered-gray-radius'
                                 style={{
                                     marginLeft: APP_WEB_WWW ? '8px' : '8px',
                                     marginRight: '-9px',
                                     marginTop: '-1px'
                                 }}
                                 src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                window.openRightSlider(null, 'card');
                            }}/>
                        }
                    </div>
                </div>


                {/*标题名称*/}
                <div className={'flex-row-vertical-center'} style={{padding:'10px 10px 0px 20px'}}>
                        <span className='header-title font-family-semi-bold'
                              style={{marginBottom: '1px'}}>{t("Tasks")}</span>

                    <div style={{flexGrow: '1'}}></div>

                    <div className={'flex-row-vertical-center'}>
                        <div className={'flex-row-vertical-center'}
                             style={{
                                 border: '1px solid var(--border-color)',
                                 borderRadius: '8px',
                                 height: '32px',
                                 gap: '6px'
                             }}>
                            {
                                //type switcher
                                arrayTypeSwitcher.map(p => {
                                    return (
                                        <div className={p.isSelected ? 'task-switch-item-select' : ''} style={{
                                            cursor: 'pointer',
                                            margin: '0 0px',
                                            padding: '0 16px',
                                            height: '100%',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }} onClick={(e) => {
                                            const arrayNew = [...arrayTypeSwitcher];
                                            arrayNew.forEach(pppppp => {
                                                pppppp.isSelected = false;
                                            })
                                            p.isSelected = true;
                                            //save
                                            localStorage.setItem(KEY_TYPE_SWITCHER, JSON.stringify(arrayNew));
                                            setArrayTypeSwitcher(arrayNew);
                                            //这里选中select 中的单个类型。。。
                                            if (p.value == 'all') {
                                                onCheckedItemClicked({...p, value: CHECK_ALL}, true);
                                            } else {
                                                const pp = arrayLibraryTypes.find(ppp => ppp.value == p.value);
                                                onCheckOneItem(pp);
                                            }
                                        }}>
                                                <span className={'span-single-line flex-center'} style={{
                                                    textAlign: 'center',
                                                    color: p.isSelected ? 'var(--primary-color)' : 'var(--text-color)'
                                                }}>{p.label}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={'flex-center ml-12 hovered'} style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            border: '1px solid var(--border-color)',
                        }} onClick={() => {
                            dialogTasksTypeSwitcherRef.current?.onShowDialog((arraySelected: any) => {
                                arraySelected.forEach(p => {
                                    p.isSelected = false;
                                })
                                let arrayCheckedTypes = arrayLibraryTypes.filter(p => p.isChecked);
                                if (arrayCheckedTypes.length == 1) {
                                    let cur = arraySelected.find(p => p.value == arrayCheckedTypes[0].value);
                                    if (cur) {
                                        cur.isSelected = true;
                                    }
                                }

                                //设置选择的...
                                arraySelected.splice(0, 0, {
                                    value: 'all',
                                    label: t("All"),
                                    isSelected: arrayCheckedTypes.length == arrayLibraryTypes.length
                                })
                                localStorage.setItem(KEY_TASK_TYPE_SWITCHER, JSON.stringify(arraySelected));
                                setArrayTypeSwitcher(arraySelected);
                            });
                        }}>
                            <img className={'img-14  cursor-pointer'}
                                 src={getImagePathWithTheme('type_switch_setting.svg')}/>
                        </div>
                    </div>
                </div>

                {/*task列表task列表task列表task列表task列表task列表task列表task列表task列表task列表task列表task列表task列表*/}
                <div style={{padding:'20px 20px'}}>

                    {
                        isEmptyTask && //默认有个no tags 和横线....
                        <span style={{margin: '0px 12px 0px 0px'}}>{t("NoTasksYet")}</span>
                    }

                    <>
                        {renderCategorySection('Today', filteredTasks.Today,'#2563EB')}
                        {renderCategorySection('Overdue', filteredTasks.Overdue,'#DC2626')}
                        {renderCategorySection('Upcoming', filteredTasks.Upcoming,'#16A34A')}
                        {renderCategorySection('NoDuedate', filteredTasks.NoDuedate,'#000000')}
                        {renderCategorySection('Complete', filteredTasks.Complete,'#666666')}
                    </>

                </div>
            </div>

            {/*right*/}
            {
                <div style={{width: `${rightSliderWidth}px`, flexShrink: '0'}}></div>
            }


            <DialogTasksTypeSwitcher ref={dialogTasksTypeSwitcherRef} onCloseCallback={()=>{

            }}/>
        </div>

    )
})

export default PageTask;